import {SelectItem} from 'primeng/primeng'

export interface IDepositsColumn {
    field: string,
    header: string,
    style: any,
    show: boolean,
    sort: boolean,
    editable: boolean,
    checked?: boolean,
    disabled: boolean,
}

export class UnapprovedRemittancesTableHelper {
    public PromotedBatchColumns: IDepositsColumn[]

    constructor() {
        this.generateBatchesColumns()
    }

    generateBatchesColumns(): void {
        this.PromotedBatchColumns = [
            { field: "ClientId", header: "Client Id", style: {}, sort: true, show: true, editable: false, disabled: false },
            //{ field: "CheckRef", header: "Check Ref Num", style: { width: "10%" }, sort: true, show: true, editable: false, disabled: false },
            { field: "CarrierId", header: "Carrier", style: {}, sort: true, show: true, editable: false, disabled: false },
            { field: "CheckNum", header: "Check Number", style: {}, sort: true, show: true, editable: false, disabled: false },
            { field: "CheckAmount", header: "Check Amount", style: {}, sort: true, show: true, editable: false, disabled: false },
            { field: "DepositDate", header: "Deposit Date", style: {}, sort: true, show: true, editable: false, disabled: false },
            { field: "SubmittedBy", header: "Submission User", style: {}, sort: true, show: true, editable: false, disabled: false },
            { field: "DateSubmitted", header: "Date Submitted", style: {}, sort: true, show: true, editable: false, disabled: false },
            { field: "Comment", header: "Comment", style: { "max-width": "400px" }, sort: true, show: true, editable: false, disabled: false },
        ]
    }
}



// WEBPACK FOOTER //
// ./src/app/components/deposit-search/unapproved-remittances/unapproved-remittances.tableHelper.ts